import { render } from "./AssignLotToBuyer.vue?vue&type=template&id=0c01ec52&scoped=true"
import script from "./AssignLotToBuyer.vue?vue&type=script&lang=js"
export * from "./AssignLotToBuyer.vue?vue&type=script&lang=js"

import "./AssignLotToBuyer.vue?vue&type=style&index=0&id=0c01ec52&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c01ec52"]])

export default __exports__